import styled from 'styled-components';

export default styled.td`
  white-space: nowrap;
  font-weight: bold;
  color: red;
`;
